import { useHistory, useLocation } from 'react-router';

export const useCloseUrlModal = () => {
    const history = useHistory();
    const { pathname } = useLocation();

    let popupIndex;

    const splittedUrl = pathname.split('/').filter((u, i) => {
        if (u.includes('popup')) {
            popupIndex = i;
            return false;
        }

        if (!u) return false;
        if (i > popupIndex) return false;

        return true;
    });

    const backgroundUrl = splittedUrl.join('/');

    return () => history.push(`/${backgroundUrl}`);
};
